<script setup lang="ts">
defineProps<{
  logoUrl?: string
  brandName: string
}>()
</script>

<template>
  <div class="bg-white p-4 rounded-lg" style="width: 96px; height: 96px;">
    <div v-if="logoUrl" class="w-16 h-16 min-w-[64px] min-h-[64px] flex items-center justify-center">
      <img
        :src="`/api/proxy/image?url=${encodeURIComponent(logoUrl)}`"
        :alt="`${brandName} logo`"
        width="64"
        height="64"
        class="w-16 h-16 object-contain"
        loading="eager"
        decoding="async"
        fetchpriority="high"
      >
    </div>
    <div v-else class="w-16 h-16 min-w-[64px] min-h-[64px] bg-gray-100 rounded-lg flex items-center justify-center">
      <span class="text-xl font-semibold text-gray-400">{{ brandName?.charAt(0) || '?' }}</span>
    </div>
  </div>
</template>
